import {
  NEW_INVOICE_COLLECTION,
  NEW_INVOICE_ITEMS,
  NEW_INVOICES,
  NEW_SINGLE_INVOICE,
  SEND_COLLECTION_NOTICE,
  INVOICES_TO_PAY,
  NEW_SINGLE_CREDIT_NOTE,
  NEW_FILTERS,
  NEW_LOADING_TABLE,
  NEW_SEARCHING,
  RELOAD_INVOIDE_TABLE,
  NEW_STATS,
  NEW_VALUES,
  CHANGE_INVOICE_SELECT
} from '../actions/invoiceActions';

import { RESET_ACCOUNT, LOG_OUT } from '../actions/accountActions';

// Dependencies
import get from 'lodash/get';

// JSON
import invoiceFilters from '../../data/invoiceFilters.json';

const initialState = {
  collection: [],
  page: null,
  filters_stats: {},
  invoice: {},
  invoicesToPay: [],
  credit_note: null,
  activeFilters: [
    ...get(invoiceFilters, 'defaultActiveFiltersInvoice'),
    ...get(invoiceFilters, 'defaultTagFiltersInovice')
  ],
  activeFiltersReminders: [
    {
      label: 'Fecha facturas',
      filterKey: 'due',
      type: 'date',
      filterCondition: 'btw',
      value: '',
      period: 'Todo'
    },
    {
      label: 'Buscar',
      filterKey: 'general',
      type: 'search',
      value: '',
      personalized: true
    },
    {
      label: 'Página',
      filterKey: 'page',
      type: 'page',
      value: 1,
      personalized: true
    },
    {
      label: 'Tabs',
      filterKey: 'type',
      type: 'tab',
      value: '', // => 'Todos'
      activeTab: '1',
      personalized: true
    },
    {
      label: 'Estado',
      filterKey: 'status',
      type: 'options',
      options: [
        { label: 'Vencidas', value: 'late_payment' },
        { label: 'Vigentes', value: 'current' },
        { label: 'Pagadas', value: 'paid' },
        { label: 'Canceladas', value: 'cancel' }
        // { label: 'Sin pagar(vigentes y vencidas)', value: 'unpaid' }
      ],
      value: 'late_payment',
      personalized: true
    }
  ],
  updateTable: true,
  searching: false,
  loadingTable: false,
  defaultTagFiltersInovice: get(invoiceFilters, 'defaultTagFiltersInovice', []),
  defaultTagFiltersCreditNote: get(invoiceFilters, 'defaultTagFiltersCreditNote'),
  invoiceItems: [],
  reloadInvoiceTable: false,
  initialValuesTags: {
    Tipo: {
      cfdi: false,
      invoice: false
    },
    Estado: {
      late_payment: false,
      current: false,
      paid: false,
      cancel: false
    },
    Origen: {
      ar: false,
      bar: false,
      xml: false,
      sat: false
    }
  },
  selected: []
}; // END initialState

export default function (state = initialState, action) {
  let { payload, type } = action,
    newState;
  switch (type) {
    case SEND_COLLECTION_NOTICE:
      newState = { last_message: payload };
      return { ...state, ...newState };

    case NEW_INVOICE_COLLECTION:
      newState = { collection: payload };
      return { ...state, ...newState };

    case NEW_SINGLE_INVOICE:
      newState = { invoice: payload };
      return { ...state, ...newState };

    case NEW_INVOICES:
      newState = { page: payload || [] };
      return { ...state, ...newState };
    case NEW_STATS:
      newState = { filters_stats: payload || [] };
      return { ...state, ...newState };

    case INVOICES_TO_PAY:
      newState = { invoicesToPay: payload };
      return { ...state, ...newState };

    case NEW_SINGLE_CREDIT_NOTE:
      newState = { credit_note: payload };
      return { ...state, ...newState };

    case NEW_INVOICE_ITEMS:
      newState = { invoiceItems: payload };
      return { ...state, ...newState };

    case NEW_FILTERS:
      const isInvoices = get(window, 'location.pathname', '').includes('invoices');
      newState = {
        [isInvoices ? 'activeFilters' : 'activeFiltersReminders']: payload.filters,
        updateTable: payload.updateTable,
        searching: payload.searching
      };
      return { ...state, ...newState };
    case NEW_VALUES:
      newState = {
        initialValuesTags: payload
      };
      return { ...state, ...newState };

    case NEW_LOADING_TABLE:
      newState = { loadingTable: payload };
      return { ...state, ...newState };

    case NEW_SEARCHING:
      newState = { searching: payload };
      return { ...state, ...newState };

    case RESET_ACCOUNT:
    case LOG_OUT:
      newState = { initialState };
      return { ...state, ...initialState };
    case RELOAD_INVOIDE_TABLE:
      return { ...state, reloadInvoiceTable: payload };
    case CHANGE_INVOICE_SELECT: {
      return {
        ...state,
        selected: action.payload.data
      }
    }
    default:
      return state;
  } // END switch
} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/invoiceReducer.js